import { v4 as uuid } from 'uuid';

export class BillingRate {
    id = uuid();

    rate = null;

    otRate = null;

    altRate = null;

    effectiveDate = new Date();

    expirationDate = null;

    current = false;

    isTaxable = false;

    qBInventoryItemId = null;

    quickbooksInventoryItemName = null;
}

export const BillingRateTypes = {
    CHARGE_TYPE: 'CHARGE_TYPE',
    CHARGE_TYPE_GROUP: 'CHARGE_TYPE_GROUP',
};
